// import gsap from '@ptchr/gsap/all';

// gsap.registerPlugin({
// 	name: 'gradient',
// 	init(target, value) {
// 		let forceDeg = value => ~value.indexOf('deg') ? value : (value = value.split('(')) && value.shift() + '(180deg, ' + value.join('(');
// 		this.add(target.style, 'backgroundImage', forceDeg(window.getComputedStyle(target).backgroundImage + ''), forceDeg(value));
// 	}
// });

// window.addEventListener('load', () => {
// 	const themes = ['blue', 'orange', 'purple', 'green', 'darkblue']
// 	themes.forEach(theme => {
// 		const target = [
// 			...document.querySelectorAll(`section[data-theme=${theme}]`),
// 			...document.querySelectorAll(`[page-theme=${theme}] .o-header`)
// 		]
// 		if(target.length) {
// 			const tl = gsap.timeline({ repeat: -1, yoyo: true });
// 			let gradient;
// 			let arr = []

// 			if(theme === 'blue') {
// 				gradient = (deg = 134) => `linear-gradient(${deg}deg, #3793FF 0%, #2AE8C4 100%)`
// 				// gradientEnd = (deg = 250) => `linear-gradient(${deg}deg, #2AE8C4 0%, #3793FF 100%)`
// 				arr = [134, 250]
// 			} else if(theme === 'orange') {
// 				gradient = (deg = 138) => `linear-gradient(${deg}deg, #FFB340 0%, #FF7474 100%)`
// 				// gradientEnd = (deg = 250) => `linear-gradient(${deg}deg, #FF7474 0%, #FFB340 100%)`
// 				arr = [138, 250]
// 			} else if(theme === 'purple') {
// 				gradient = (deg) => `linear-gradient(${deg}deg, #8037FF 0%, #FD8E9E 100%)`
// 				// gradientEnd = (deg) => `linear-gradient(${deg}deg, #FD8E9E 0%, #8037FF 100%)`
// 				arr = [134, 250]
// 			} else if(theme === 'green') {
// 				gradient = (deg) => `linear-gradient(${deg}deg, #2ADC98 0%, #FFD862 100%)`
// 				// gradientEnd = (deg) => `linear-gradient(${deg}deg, #FFD862 0%, #2ADC98 100%)`
// 				arr = [132, 250]
// 			} else if(theme === 'darkblue') {
// 				gradient = (deg) => `linear-gradient(${deg}deg, #71C1CE 0%, #4B3EE1 100%)`
// 				// gradientEnd = (deg) => `linear-gradient(${deg}deg, #4B3EE1 0%, #71C1CE 100%)`
// 				arr = [132, 250]
// 			}

// 			if(gradient) {
// 				arr.forEach(deg => {
// 					// tl.to(target, {
// 					// 	duration: 3,
// 					// 	gradient: gradientEnd(deg)
// 					// })
// 					tl.to(target, {
// 						duration: 3,
// 						gradient: gradient(deg)
// 					})
// 				});
// 			}
// 		}
// 	});
// })



// WEBPACK FOOTER //
// ./js/modules/animations/gradient.js